import { useState } from "react";
import AdministratorsTab from "./AdministratorsTab";
import SecurityQuestionsTab from "./SecurityQuestionsTab";
import LockedUsersTab from "./LockedUsersTab";
import SystemSettingsTab from "./SystemSettingsTab";
import ReportsTab from "./ReportsTab";

const AdminTabs = () => {
  const [activeTab, setActiveTab] = useState("admin");

  const renderTab = () => {
    switch (activeTab) {
      case "admin":
        return <AdministratorsTab />;
      case "security":
        return <SecurityQuestionsTab />;
      case "locked":
        return <LockedUsersTab />;
      case "system":
        return <SystemSettingsTab />;
      case "reports":
        return <ReportsTab />;
      default:
        return null;
    }
  };

  const getClass = (tab) =>
    activeTab === tab ? "active" : "";

  return (
    <>
      <ul
        className="nav nav-tabs"
        id="WebUserAdminTabs"
        role="tablist"
      >
        <li
          role="presentation"
          className={getClass("admin")}
        >
          <a
            onClick={() => setActiveTab("admin")}
          >
            Administrators Management
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("security")}
        >
          <a
            onClick={() => setActiveTab("security")}
          >
            Security Questions
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("locked")}
        >
          <a
            onClick={() => setActiveTab("locked")}
          >
            Locked Users
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("system")}
        >
          <a
            onClick={() => setActiveTab("system")}
          >
            System Settings
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("reports")}
        >
          <a
            onClick={() => setActiveTab("reports")}
          >
            Reports
          </a>
        </li>
      </ul>

      <div className="tab-content">
        {renderTab()}
      </div>
    </>
  );
};

export default AdminTabs;